module.exports = __webpack_public_path__ + "static/linkedinsales-fdc6d5d9fcdc1d1893680af6d725a2b9.jpg";